// @flow
export default class Storage {
  setItem (key, value) {
    if (process.browser) {
      return Promise.reject(new Error('该方法目前不支持'))
    }
    return false
  }

  setItemSync (key, value) {
    if (process.browser) {
      try {
        window.localStorage.setItem(key, value)
        return true
      } catch (e) {
        console.error(e)
        return false
      }
    }
    return false
  }

  getItem (key) {
    if (process.browser) {
      return Promise.reject(new Error('该方法目前不支持'))
    }
    return false
  }

  getItemSync (key) {
    if (process.browser) {
      try {
        return window.localStorage.getItem(key)
      } catch (e) {
        console.error(e)
        return null
      }
    }
    return false
  }

  removeItem (key) {
    if (process.browser) {
      return Promise.reject(new Error('该方法目前不支持'))
    }
    return false
  }

  removeItemSync (key) {
    if (process.browser) {
      try {
        window.localStorage.removeItem(key)
        return true
      } catch (e) {
        console.error(e)
        return false
      }
    }
    return false
  }

  clear () {
    if (process.browser) {
      return Promise.reject(new Error('该方法目前不支持'))
    }
    return false
  }

  clearSync () {
    if (process.browser) {
      try {
        window.localStorage.clear()
        return true
      } catch (e) {
        console.error(e)
        return false
      }
    }
    return false
  }
}
